module.exports = __webpack_public_path__ + "static/media/edit_button.6c7745c2.svg";